<template>
  <v-container fluid>
    <v-row no-gutters>
      <v-col cols="12">
        <v-card>
          <v-data-table
              :headers="headers"
              :items="dataItems"
              :loading="loading"
              :search="search"
              class="elevation-1"
              item-key="id"
          >
            <template v-slot:top>
              <v-toolbar flat>
                <v-toolbar-title>
                  Public Relations Statistics
                </v-toolbar-title>
                <v-spacer></v-spacer>
                <v-text-field
                    v-model="search"
                    append-icon="mdi-magnify"
                    hide-details
                    label="Search Public Relations"
                    single-line
                ></v-text-field>
                <v-menu
                    ref="menu"
                    v-model="menu"
                    :close-on-content-click="false"
                    max-width="50%"
                    transition="scale-transition"
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-text-field
                        v-model="dateFormatted"
                        v-bind="attrs"
                        v-on="on"
                        hint="DD/MM/YYYY format"
                        label="Date"
                        persistent-hint
                        prepend-icon="mdi-calendar"
                    ></v-text-field>
                  </template>

                  <!--
                    Alerts & Loaders
                  -->
                  <Loader :loading="loadingCreateUpdateDelete"/>
                  <!--<Alerts :aType.sync="response"/>-->

                  <v-date-picker
                      ref="picker"
                      v-model="date"
                      :max="new Date().toISOString().substr(0, 10)"
                      min="1950-01-01"
                      @change="save"
                  ></v-date-picker>
                </v-menu>

                <v-btn

                    class="ml-1"
                    color="primary"
                    dark
                    icon
                    @click="clearDate"
                >
                  <v-icon>mdi-eraser</v-icon>
                </v-btn>

              </v-toolbar>
            </template>

          </v-data-table>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import {manager_get_prs_stats} from "../../modules/nite_api";
import moment from "moment";
import Loader from "../shared/Loader"
import VueNotifications from "vue-notifications";


export default {
  components: {
    Loader
  },
  data: () => ({

    response: null,
    loading: false,
    loadingCreateUpdateDelete: false,
    dialog: false,
    dialogDelete: false,
    search: '',
    date: null,
    dateFormatted: '',
    menu: false,
    headers: [
      {
        text: 'Name',
        align: 'start',
        sortable: true,
        value: 'pr_fullname',
      },
      {text: 'PR Shortcode', value: 'pr_shortcode', sortable: true},
      {text: 'Occurrences', value: 'pr_occurrences', sortable: true},
    ],
    dataItems: [],

  }),

  watch: {

    menu(val) {
      val && setTimeout(() => (this.$refs.picker.activePicker = "YEAR"));

    },
  },

  methods: {
    save(date) {
      this.$refs.menu.save(date);
      this.dateFormatted = date ? moment(date).format('DD-MM-YYYY') : '';
      this.closeMenu();
    },

    async closeMenu() {

      await this.getDataFromApi()

      this.menu = false
    },

    clearDate() {
      this.date = '';
      this.dataItems = [];
    },

    async getDataFromApi() {
      this.loading = true
      try {


        const response = await manager_get_prs_stats(this.date);
        // Success
        this.dataItems = response.data;
        console.log(response);

      } catch (error) {
        // Error
        if (error.response) {
          /*
           * The request was made and the server responded with a
           * status code that falls out of the range of 2xx
           */
          console.log(error.response.data);
          console.log(error.response.status);
          this.response = error.response.status;


          console.log(error.response.headers);
        } else if (error.request) {
          /*
           * The request was made but no response was received, `error.request`
           * is an instance of XMLHttpRequest in the browser and an instance
           * of http.ClientRequest in Node.js
           */
          console.log(error.request);
        } else {
          // Something happened in setting up the request and triggered an Error
          console.log('Error', error.message);
        }
        console.log(error.config);
      } finally {

        this.loading = false;
        switch (this.response) {
          case 200:
                break;
          case 500:
            this.showErrorMsg({
              title: 'Error',
              message: 'Something went wrong with the request. Please try again later!'
            });
            break;
          default:
            break;
        }

      }
    },
  },
  notifications: {
    showSuccessMsg: {
      type: VueNotifications.types.success,
      title: 'Hello there',
      message: 'That\'s the success!'
    },
    showInfoMsg: {
      type: VueNotifications.types.info,
      title: 'Hey you',
      message: 'Here is some info for you'
    },
    showWarnMsg: {
      type: VueNotifications.types.warn,
      title: 'Wow, man',
      message: 'That\'s the kind of warning'
    },
    showErrorMsg: {
      type: VueNotifications.types.error,
      title: 'Wow-wow',
      message: 'That\'s the error'
    }
  }
}
</script>

<style scoped>


</style>
